angular.module('aprima-core-ui').directive('apMessageAssignTo', [function () {
    'use strict';

    return {
        scope: {
            message: '=',
            userList: '=',
            users: '=',
            clickHandler: '=',
            reassignHandler: '='
        },
        templateUrl: '/core-ui/views/directives/apMessageAssignTo.html',
        link: function (scope) {

            if (!scope.message) {
                throw new Error('apMessageAssignTo: message is undefined');
            }
            if (!scope.userList) {
                throw new Error('apMessageAssignTo: userList is undefined');
            }
            if (!scope.clickHandler) {
                throw new Error('apMessageAssignTo: clickHandler is undefined');
            }
            if (!scope.reassignHandler) {
                throw new Error('apMessageAssignTo: reassignHandler is undefined');
            }
            if (!scope.users) {
                throw new Error('apMessageAssignTo: users is undefined');
            }

        }
    };

}]);